// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface TwitterIconSignature {
  Element: SVGSVGElement;
}

export const TwitterIcon: TOC<TwitterIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M22.3 6C21.6 6.3 20.8 6.5 19.9 6.6C20.8 6.1 21.4 5.3 21.7 4.3C20.9 4.8 20 5.1 19.1 5.3C18.3 4.5 17.3 4 16.1 4C13.8 4 12 5.8 12 8.1C12 8.4 12 8.7 12.1 9C8.7 8.8 5.7 7.2 3.6 4.7C3.2 5.3 3 6 3 6.8C3 8.2 3.7 9.5 4.8 10.2C4.1 10.2 3.5 10 2.9 9.7C2.9 11.7 4.3 13.3 6.2 13.7C5.9 13.8 5.5 13.8 5.1 13.8C4.8 13.8 4.6 13.8 4.3 13.7C4.8 15.3 6.3 16.5 8.1 16.6C6.7 17.7 4.9 18.3 3 18.3C2.7 18.3 2.3 18.3 2 18.2C3.8 19.4 6 20 8.3 20C15.8 20 20 13.8 20 8.3C20 8.1 20 7.9 20 7.8C21.1 7.5 21.7 6.8 22.3 6Z"/>
</svg>
</template>;